var _rect, _rect2;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
var SvgBorderLoading = function SvgBorderLoading(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    fill: "none",
    preserveAspectRatio: "none",
    viewBox: "0 0 46 26"
  }, props), _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    width: 44,
    height: 24,
    x: 1,
    y: 1,
    stroke: "var(--color-main-border, #CDC3FF)",
    rx: "5%"
  })), _rect2 || (_rect2 = /*#__PURE__*/React.createElement("rect", {
    width: 44,
    height: 24,
    x: 1,
    y: 1,
    stroke: "var(--color-main-secondary-text, #5835FF)",
    strokeDasharray: 66,
    strokeDashoffset: 597,
    rx: "5%"
  }, /*#__PURE__*/React.createElement("animate", {
    attributeName: "stroke-dashoffset",
    dur: "2.5s",
    repeatCount: "indefinite",
    values: "597;200"
  }))));
};
export default SvgBorderLoading;